export function toFormData(dataObject) {
  const formData = new FormData();

  Object.entries(dataObject).forEach(([key, value]) => {
    if (value instanceof File) {
      formData.append(key, value);
    } else if (value && typeof value === 'object' && value.file instanceof File) {
      formData.append(key, value.file);
    } else if (Array.isArray(value)) {
      value.forEach((item) => {
        formData.append(`${key}[]`, item);
      });
    } else if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  return formData;
}

export function toSelectOptions(dataArray) {
  return Object.entries(dataArray).map(([value, label]) => ({
    value,
    label,
  }));
}



// WEBPACK FOOTER //
// ./resources/js/app/helpers.js